import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/JacobShilue/subs.vtt';
import poster from '@/static/assets/reviews/JacobShilue/video.jpg';

export const JacobShilue: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Renters],
  reviewerName: 'Jacob',
  videoUrl: `${ASSETS_URL}/renters/JacobShilue_Renters.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
